import axios from "axios";
import { LOGIN, SIGNUP } from "./actionTypes";

export const loginAPI = (username, password) => (dispatch) => {
	const requestData = {
		login_username: username,
		login_password: password,
	};

	return axios
		.post("/login", requestData)
		.then((response) => {
			if (response.data.token === "Missing or False") {
				alert("Fout bij het inloggen, probeer opnieuw");
				return;
			} else {
				window.localStorage.clear();
				let body = response.data.data;

				const loginData = {
					token: body.token,
					user_id: body.user_id,
					firstName: body.firstname,
					lastName: body.lastname,
					all_locations: body.locations,
					current_location: body.locations[0],
					authorization: body.authorization,
					loginSuccesful: body.login,
					logo: body.logo,
					payoff: body.payoff,
					stylesheet: "https://easyapp.bestelsysteem.net" + body.stylesheet,
					add_barcodes: body.add_barcodes,
					stock_count: body.stock_count,
					show_locations: body.show_locations,
					farmers: body.farmers,
					favicon: body.favicon,
					business: body.business,
					delivery: body.delivery,
					pickup: body.pickup,
					pay_online: body.pay_online,
				};
				dispatch({ type: LOGIN, payload: loginData });
				axios.defaults.headers.common["Token"] = loginData.token;
				axios.defaults.headers.common["Authorization"] =
					loginData.authorization;
			}
		})
		.catch((err) => {
			console.log(
				"[login.actions.js] loginAPI || Could not fetch login. Try again later."
			);
		});
};

export const loginWithKey = (querystringKey) => (dispatch) => {
	const requestData = {
		key: querystringKey,
	};

	return axios
		.post("/login", requestData)
		.then((response) => {
			if (response.data.data.token === "Missing or False") {
				alert("Fout bij het inloggen, probeer opnieuw");
				return;
			} else {
				window.localStorage.clear();
				let body = response.data.data;

				const loginData = {
					token: body.token,
					user_id: body.user_id,
					firstName: body.firstname,
					lastName: body.lastname,
					all_locations: body.locations,
					current_location: body.locations[0],
					authorization: body.authorization,
					loginSuccesful: body.login,
					logo: body.logo,
					payoff: body.payoff,
					stylesheet: "https://easyapp.bestelsysteem.net" + body.stylesheet,
					add_barcodes: body.add_barcodes,
					stock_count: body.stock_count,
					show_locations: body.show_locations,
					farmers: body.farmers,
					favicon: body.favicon,
					business: body.business,
					delivery: body.delivery,
					pickup: body.pickup,
					pay_online: body.pay_online,
				};

				axios.defaults.headers.common["Token"] = loginData.token;
				axios.defaults.headers.common["Authorization"] =
					loginData.authorization;
				dispatch({ type: LOGIN, payload: loginData });
			}
		})
		.catch((err) => {
			console.log(
				"[login.actions.js] loginAPI || Could not fetch login. Try again later."
			);
		});
};

export const signUpAPI =
	(
		firstname,
		lastname,
		adres,
		zipcode,
		city,
		phonenumber,
		email,
		signupCode,
		verficationViaSMS
	) =>
	(dispatch) => {
		const requestData = {
			email: email,
			phonenumber: phonenumber,
			firstname: firstname,
			lastname: lastname,
			address: adres,
			postcode: zipcode,
			city: city,
			signup_code: signupCode,
			sms: verficationViaSMS === "true",
		};
		return axios
			.post("/signup", requestData)
			.then((response) => {
				if (response.data.code === 200) {
					const responseData = {
						phonenumber: phonenumber,
						key: response.data.key,
						message: response.data.message,
					};
					dispatch({ type: SIGNUP, payload: responseData });
					return responseData;
				} else if (response.data.code === 404) {
					alert(response.data.message);
					return response.data.code;
				} else {
					alert(response.data.message);
					window.location.reload(false);
				}
			})
			.catch((err) => {
				console.log(
					"[login.actions.js] signUpAPI || Could not fetch login. Try again later."
				);
			});
	};

export const confirmSignUpAPI = (key, code) => () => {
	const requestData = {
		key: key,
		code: code,
	};
	return axios
		.post("/confirm_signup", requestData)
		.then((response) => {
			if (response.data.token === "Missing or False") {
				alert("Fout bij het inloggen, probeer opnieuw");
				return;
			} else {
				alert(response.data.message);
			}
		})
		.catch((err) => {
			console.log(
				"[login.actions.js] confirmSignUpAPI || Could not fetch login. Try again later."
			);
		});
};
